import type { ComponentMeta } from "@mijalowcode/types";
import { ComponentCategory, PropType } from "@mijalowcode/types";

export const TreeMeta: ComponentMeta = {
  componentName: "Tree",
  package: "@mijadesign/web",
  title: "树形控件",
  description: "多层级的内容组织，可展示可折叠的层级结构",
  category: ComponentCategory.DATA_DISPLAY,
  icon: "DatabaseOutlined",
  canHaveChildren: true,
  childrenLimit: 0,
  props: [
    {
      name: "treeData",
      label: "树数据",
      type: PropType.JSON,
      description:
        '树形数据结构，如：[{ title: "节点1", key: "1", children: [] }]',
      group: "数据",
    },
    {
      name: "defaultExpandAll",
      label: "默认展开全部",
      type: PropType.BOOLEAN,
      defaultValue: false,
      group: "展开",
    },
    {
      name: "defaultExpandedKeys",
      label: "默认展开节点",
      type: PropType.ARRAY,
      group: "展开",
    },
    {
      name: "autoExpandParent",
      label: "自动展开父节点",
      type: PropType.BOOLEAN,
      defaultValue: true,
      group: "展开",
    },
    {
      name: "checkable",
      label: "显示复选框",
      type: PropType.BOOLEAN,
      defaultValue: false,
      group: "功能",
    },
    {
      name: "showLine",
      label: "显示连接线",
      type: PropType.BOOLEAN,
      defaultValue: false,
      group: "展示",
    },
    {
      name: "showIcon",
      label: "显示图标",
      type: PropType.BOOLEAN,
      defaultValue: false,
      group: "展示",
    },
    {
      name: "draggable",
      label: "支持拖拽",
      type: PropType.BOOLEAN,
      defaultValue: false,
      group: "功能",
    },
    {
      name: "disabled",
      label: "禁用",
      type: PropType.BOOLEAN,
      defaultValue: false,
      group: "状态",
    },
    {
      name: "selectable",
      label: "可选中",
      type: PropType.BOOLEAN,
      defaultValue: true,
      group: "功能",
    },
    {
      name: "multiple",
      label: "多选",
      type: PropType.BOOLEAN,
      defaultValue: false,
      group: "功能",
    },
  ],
  defaultProps: {
    treeData: [
      {
        title: "节点1",
        key: "1",
        children: [
          { title: "节点1-1", key: "1-1" },
          { title: "节点1-2", key: "1-2" },
        ],
      },
      {
        title: "节点2",
        key: "2",
        children: [{ title: "节点2-1", key: "2-1" }],
      },
    ],
    defaultExpandAll: true,
  },
  npm: {
    package: "@mijadesign/web",
    exportName: "Tree",
  },
  snippet: {
    componentName: "Tree",
    package: "@mijadesign/web",
    props: {
      treeData: [
        {
          title: "节点1",
          key: "1",
          children: [{ title: "节点1-1", key: "1-1" }],
        },
        { title: "节点2", key: "2" },
      ],
    },
  },
};

export const TreeSelectMeta: ComponentMeta = {
  componentName: "TreeSelect",
  package: "antd",
  title: "树选择",
  description: "下拉树形选择器，用于从树形结构中选择一个或多个节点",
  category: ComponentCategory.FORM,
  icon: "SolutionOutlined",
  canHaveChildren: false,
  props: [
    {
      name: "treeData",
      label: "树数据",
      type: PropType.JSON,
      group: "数据",
    },
    {
      name: "placeholder",
      label: "占位提示",
      type: PropType.STRING,
      defaultValue: "请选择",
      group: "基础",
    },
    {
      name: "allowClear",
      label: "可清空",
      type: PropType.BOOLEAN,
      defaultValue: true,
      group: "功能",
    },
    {
      name: "multiple",
      label: "多选",
      type: PropType.BOOLEAN,
      defaultValue: false,
      group: "功能",
    },
    {
      name: "treeCheckable",
      label: "树形复选框",
      type: PropType.BOOLEAN,
      defaultValue: false,
      group: "功能",
    },
    {
      name: "showSearch",
      label: "显示搜索",
      type: PropType.BOOLEAN,
      defaultValue: false,
      group: "功能",
    },
    {
      name: "treeDefaultExpandAll",
      label: "默认展开全部",
      type: PropType.BOOLEAN,
      defaultValue: false,
      group: "展开",
    },
    {
      name: "disabled",
      label: "禁用",
      type: PropType.BOOLEAN,
      defaultValue: false,
      group: "状态",
    },
  ],
  defaultProps: {
    placeholder: "请选择",
  },
  npm: {
    package: "antd",
    exportName: "TreeSelect",
  },
  snippet: {
    componentName: "TreeSelect",
    package: "antd",
    props: { placeholder: "请选择" },
  },
};
